/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Upload_Problematic_BadgeInputs */

const en_upload_problematic_badge = /** @type {(inputs: Upload_Problematic_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not related to this case`)
};

const pt_br2_upload_problematic_badge = /** @type {(inputs: Upload_Problematic_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não relacionado a este caso`)
};

/**
* | output |
* | --- |
* | "Not related to this case" |
*
* @param {Upload_Problematic_BadgeInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const upload_problematic_badge = /** @type {((inputs?: Upload_Problematic_BadgeInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Upload_Problematic_BadgeInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_upload_problematic_badge(inputs)
	return pt_br2_upload_problematic_badge(inputs)
});